var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconInfo = function IconInfo(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 5.832 5.832 0 16 0s16 5.832 16 16-5.832 16-16 16S0 26.168 0 16zm2 0c0 9.028 4.972 14 14 14 9.028 0 14-4.972 14-14 0-9.028-4.972-14-14-14C6.972 2 2 6.972 2 16zm15.129 8v-8h-2.258v8h2.258zm-.555-15.314c.18.075.342.175.479.3.137.127.247.277.328.453.082.176.123.363.123.563 0 .402-.146.747-.441 1.035A1.47 1.47 0 0116 11.47a1.51 1.51 0 01-1.054-.414c-.3-.276-.45-.614-.45-1.014 0-.402.147-.746.442-1.034A1.45 1.45 0 0116 8.574c.2 0 .392.037.574.112z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "iconInfo_svg__a",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 5.832 5.832 0 16 0s16 5.832 16 16-5.832 16-16 16S0 26.168 0 16zm2 0c0 9.028 4.972 14 14 14 9.028 0 14-4.972 14-14 0-9.028-4.972-14-14-14C6.972 2 2 6.972 2 16zm13 8h2.258v-8H15v8zm1.574-15.314c.18.075.342.175.479.3.137.127.247.277.328.453.082.176.123.363.123.563 0 .402-.146.747-.441 1.035A1.47 1.47 0 0116 11.47a1.51 1.51 0 01-1.054-.414c-.3-.276-.45-.614-.45-1.014 0-.402.147-.746.442-1.034A1.45 1.45 0 0116 8.574c.2 0 .392.037.574.112z",
    fill: "#fff"
  })));
};

IconInfo.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconInfo;
//# sourceMappingURL=IconInfo.js.map